const registeredBlocks = {};

function registerBlock(name, callback) {
  registeredBlocks[name] = callback;
}

function initializeBlock(name, id) {
  if (!registeredBlocks[name]) { return; }

  const element = document.getElementById(id);
  if (!element) { return; }

  const callback = registeredBlocks[name];
  if (!callback) { return; }

  callback(element);
}

// Register & render defered blocks
const deferedRegisterBlocks = (window.brix && window.brix.deferedRegisterBlocks) || [];
const deferedInitializeBlocks = (window.brix && window.brix.deferedInitializeBlocks) || [];
for (let i = 0; i < deferedRegisterBlocks.length; i += 1) {
  registerBlock(...deferedRegisterBlocks[i]);
}
for (let i = 0; i < deferedInitializeBlocks.length; i += 1) {
  initializeBlock(...deferedInitializeBlocks[i]);
}

window.brix = {
  registerBlock,
  initializeBlock,
};
